module.exports = __webpack_public_path__ + "img/icon-general-edit.42c98812.svg";